var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgView = function SvgView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 31 30"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.5,
    height: 29.5,
    x: -0.25,
    y: 0.25,
    stroke: "#B6B8B9",
    strokeWidth: 0.5,
    rx: 14.75,
    transform: "matrix(-1 0 0 1 30 0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#101010",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M17.323 10.448 21.875 15l-4.552 4.552M9.125 15h12.623"
  })));
};
export default SvgView;